import { AppContext } from "@lib/types/Context";
import ROUTES from "@lib/constants/Routes";
import { IRouteConfig } from "@lib/types/Routes";
import { AuthRoles } from "@lib/types/Auth";
import { SendByte } from "@lib/components/MiniComponents/Icons";
import { HiMiniQueueList, HiMiniUserGroup } from "react-icons/hi2";
import { GrList, GrMoney } from "react-icons/gr";
import {
  FaBell,
  FaBtc,
  FaCog,
  FaFingerprint,
  FaTelegram,
  FaUser,
} from "react-icons/fa";
import { PiGitPullRequestLight, PiUserListFill } from "react-icons/pi";
import { BiSolidDashboard, BiSolidPhoneCall } from "react-icons/bi";
import { AiOutlineFileText } from "react-icons/ai";
import { MdOutlineWifiPassword, MdPayments } from "react-icons/md";
import {
  TbAdjustmentsCog,
  TbBulb,
  TbBusinessplan,
  TbChartLine,
  TbHeartRateMonitor,
  TbNote,
  TbZoomMoney,
} from "react-icons/tb";
import { FiShoppingCart } from "react-icons/fi";
import { SlNote } from "react-icons/sl";
import { FaWhatsapp } from "react-icons/fa";
import { RiListSettingsFill, RiSecurePaymentFill } from "react-icons/ri";
import { FaHeadphonesSimple, FaPeopleGroup } from "react-icons/fa6";
import { IoBusinessSharp, IoPeople, IoWallet } from "react-icons/io5";
import { GoChecklist } from "react-icons/go";
import { SiQuicklook } from "react-icons/si";
import { LuBrainCircuit } from "react-icons/lu";
import { GiSoundWaves } from "react-icons/gi";

const adminRoutesConfig: IRouteConfig[] = [
  {
    id: "dashboards",
    title: "dashboards",
    messageId: "sidebar.dashboards",
    type: "group",
    icon: <BiSolidDashboard />,
    children: [
      {
        id: ROUTES.ADMIN.DASHBOARD.CUSTOMER,
        url: ROUTES.ADMIN.DASHBOARD.CUSTOMER,
        title: "Customer Dashboard",
        messageId: "sidebar.dashboard.customer",
        icon: <GoChecklist />,
        type: "item",
        permittedRole: AuthRoles.Admin,
      },
      {
        id: ROUTES.ADMIN.DASHBOARD.PAYMENT_PROVIDER,
        url: ROUTES.ADMIN.DASHBOARD.PAYMENT_PROVIDER,
        title: "Payment Provider Dashboard",
        messageId: "sidebar.dashboard.paymentProvider",
        icon: <RiSecurePaymentFill />,
        type: "item",
        showInBottomNav: true,
      },
      {
        id: ROUTES.ADMIN.DASHBOARD.CUSTOMER_LEAD,
        url: ROUTES.ADMIN.DASHBOARD.CUSTOMER_LEAD,
        title: "Lead Dashboard",
        messageId: "sidebar.dashboard.customerLead",
        icon: <SendByte />,
        type: "item",
        showInBottomNav: true,
      },
      {
        id: ROUTES.ADMIN.DASHBOARD.AI_PAYMENTS,
        url: ROUTES.ADMIN.DASHBOARD.AI_PAYMENTS,
        title: "AI Payments Dashboard",
        messageId: "sidebar.dashboard.aiPayments",
        icon: <LuBrainCircuit />,
        type: "item",
        showInBottomNav: true,
      },
      {
        id: ROUTES.ADMIN.DASHBOARD.TFT_SALES,
        url: ROUTES.ADMIN.DASHBOARD.TFT_SALES,
        title: "TFT Sales Dashboard",
        messageId: "sidebar.dashboard.tftSales",
        icon: <GiSoundWaves />,
        type: "item",
      },
    ],
  },

  {
    id: "monitoring",
    title: "monitoring",
    messageId: "sidebar.monitoring",
    type: "group",
    icon: <SiQuicklook />,
    children: [
      {
        id: ROUTES.MONITORING.AUDIT_LOGS.LIST,
        url: ROUTES.MONITORING.AUDIT_LOGS.LIST,
        title: "monitoring",
        messageId: "sidebar.auditLogs",
        icon: <TbHeartRateMonitor />,
        type: "item",
        children: [
          {
            id: ROUTES.MONITORING.AUDIT_LOGS.DETAIL,
            url: ROUTES.MONITORING.AUDIT_LOGS.DETAIL,
            paramKey: ROUTES.URL_PARAMS.AUDIT_LOG_ID,
            title: "Audit Log Detail",
            messageId: "sidebar.auditLogDetail",
            type: "item",
            dontShowInSidebar: true,
          },
        ],
      },

      {
        id: ROUTES.AI_LOGS.LIST,
        url: ROUTES.AI_LOGS.LIST,
        title: "AI Logs",
        messageId: "sidebar.aiLogs",
        icon: <LuBrainCircuit />,
        type: "item",
      },
    ],
  },

  {
    id: "menu",
    title: "Menu",
    messageId: "sidebar.menu",
    type: "group",
    icon: <HiMiniQueueList />,
    children: [
      {
        id: AppContext.PAYMENT_PROVIDER,
        title: "Payment Provider Transactions",
        messageId: "sidebar.paymentProviderTransactions",
        type: "collapse",
        icon: <TbBusinessplan />,
        children: [
          {
            id: ROUTES.ADMIN.PAYMENT_PROVIDER.LIST,
            url: ROUTES.ADMIN.PAYMENT_PROVIDER.LIST,
            title: "Payment Providers",
            messageId: "sidebar.paymentProviderTransactions.paymentProviders",
            icon: <GrList />,
            type: "item",
            children: [
              {
                id: ROUTES.ADMIN.PAYMENT_PROVIDER.DETAIL,
                url: ROUTES.ADMIN.PAYMENT_PROVIDER.DETAIL,
                paramKey: ROUTES.URL_PARAMS.PROVIDER_ID,
                title: "Payment Provider Detail",
                messageId: "sidebar.providerDetail",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },

          {
            id: ROUTES.ADMIN.PAYMENT_PROVIDER.MANAGER.LIST,
            url: ROUTES.ADMIN.PAYMENT_PROVIDER.MANAGER.LIST,
            title: "System Users",
            messageId: "sidebar.paymentProviderTransactions.systemUsers",
            icon: <HiMiniUserGroup />,
          },
          {
            id: ROUTES.ADMIN.PAYMENT_PROVIDER.PAYMENT_HISTORY.LIST,
            url: ROUTES.ADMIN.PAYMENT_PROVIDER.PAYMENT_HISTORY.LIST,
            title: "Payment History",
            messageId: "sidebar.paymentProviderTransactions.paymentHistory",
            icon: <MdPayments />,
          },

          {
            id: ROUTES.ADMIN.PAYMENT_PROVIDER.PAYMENT_TRANSACTION_CONFIG.LIST,
            url: ROUTES.ADMIN.PAYMENT_PROVIDER.PAYMENT_TRANSACTION_CONFIG.LIST,
            title: "Payment Transaction Configs",
            messageId:
              "sidebar.paymentProviderTransactions.paymentTransactionConfigs",
            icon: <TbAdjustmentsCog />,
          },
        ],
      },

      {
        id: AppContext.CUSTOMER,
        title: "White Label Transactions",
        messageId: "sidebar.whiteLabelTransactions",
        type: "collapse",
        icon: <IoBusinessSharp />,
        children: [
          {
            id: ROUTES.ADMIN.CUSTOMER.LIST,
            url: ROUTES.ADMIN.CUSTOMER.LIST,
            title: "White Label",
            messageId: "sidebar.whiteLabelTransactions.whiteLabels",
            icon: <GrList />,
            type: "item",
            children: [
              {
                id: ROUTES.ADMIN.CUSTOMER.DETAIL,
                url: ROUTES.ADMIN.CUSTOMER.DETAIL,
                paramKey: ROUTES.URL_PARAMS.CUSTOMER_ID,
                title: "White Label Detail",
                messageId: "sidebar.customerDetail",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },

          {
            id: ROUTES.ADMIN.CUSTOMER.MANAGER.LIST,
            url: ROUTES.ADMIN.CUSTOMER.MANAGER.LIST,
            title: "System Users",
            messageId: "sidebar.whiteLabelTransactions.systemUsers",
            icon: <HiMiniUserGroup />,
          },
          {
            id: ROUTES.ADMIN.CUSTOMER.INVOICE.LIST,
            url: ROUTES.ADMIN.CUSTOMER.INVOICE.LIST,
            title: "Invoices",
            messageId: "sidebar.whiteLabelTransactions.invoices",
            icon: <AiOutlineFileText />,
          },
          // { right now no need to show orders, but we can add it later
          //   id: "/whiteLabel/orders",
          //   url: "/whiteLabel/orders",
          //   title: "Orders",
          //   messageId: "sidebar.whiteLabelTransactions.orders",
          //   icon: <FaShoppingCart />,
          // },
          {
            id: ROUTES.ADMIN.CUSTOMER.WALLET_ACCOUNTS.LIST,
            url: ROUTES.ADMIN.CUSTOMER.WALLET_ACCOUNTS.LIST,
            title: "Wallet Accounts",
            messageId: "sidebar.whiteLabelTransactions.walletAccounts",
            icon: <FaBtc />,
          },
          {
            id: ROUTES.ADMIN.CUSTOMER.BLOCKCHAIN_PAYMENT_REQUEST.LIST,
            url: ROUTES.ADMIN.CUSTOMER.BLOCKCHAIN_PAYMENT_REQUEST.LIST,
            title: "Blockchain Payment Requests",
            messageId: "sidebar.blockchainPaymentRequest",
            icon: <PiGitPullRequestLight />,
          },
          {
            id: ROUTES.ADMIN.CUSTOMER.BLOCKCHAIN_PAYMENTS.LIST,
            url: ROUTES.ADMIN.CUSTOMER.BLOCKCHAIN_PAYMENTS.LIST,
            title: "Blockchain Payments",
            messageId: "sidebar.whiteLabelTransactions.blockchainPayments",
            icon: <TbZoomMoney />,
          },
          {
            id: ROUTES.ADMIN.CUSTOMER.CASH_PAYMENT_HISTORY.LIST,
            url: ROUTES.ADMIN.CUSTOMER.CASH_PAYMENT_HISTORY.LIST,
            title: "Cash Payment History",
            messageId: "sidebar.cashPaymentHistory",
            icon: <GrMoney />,
            type: "item",
          },
          // {
          //   id: ROUTES.ADMIN.CUSTOMER.PAYMENT_HISTORY.LIST,
          //   url: ROUTES.ADMIN.CUSTOMER.PAYMENT_HISTORY.LIST,
          //   title: "Payment History",
          //   messageId: "sidebar.paymentHistory",
          //   icon: <MdPayments />,
          // },

          {
            id: ROUTES.AI_PAYMENTS.WALLET_LIST,
            url: ROUTES.AI_PAYMENTS.WALLET_LIST,
            title: "AI Wallets",
            messageId: "sidebar.aiWallets",
            icon: <FaBtc />,
          },
          {
            id: ROUTES.AI_PAYMENTS.BLOCKCHAIN_PAYMENT_REQUESTS,
            url: ROUTES.AI_PAYMENTS.BLOCKCHAIN_PAYMENT_REQUESTS,
            title: "AI Blockchain Payment Requests",
            messageId: "sidebar.aiBlockchainPaymentRequests",
            icon: <PiGitPullRequestLight />,
          },
          {
            id: ROUTES.AI_PAYMENTS.BLOCKCHAIN_PAYMENTS,
            url: ROUTES.AI_PAYMENTS.BLOCKCHAIN_PAYMENTS,
            title: "AI Blockchain Payments",
            messageId: "sidebar.aiBlockchainPayments",
            icon: <TbZoomMoney />,
          },
        ],
      },

      {
        id: AppContext.CUSTOMER_LEAD,
        title: "WhiteLabel Lead Transactions",
        messageId: "sidebar.whiteLabelLeadTransactions",
        type: "collapse",
        icon: <FaPeopleGroup />,
        children: [
          {
            id: ROUTES.ADMIN.CUSTOMER_LEAD.LIST,
            url: ROUTES.ADMIN.CUSTOMER_LEAD.LIST,
            title: "White Label Lead",
            messageId: "sidebar.whiteLabelLeadTransactions.whiteLabelLead",
            icon: <GrList />,
            type: "item",
            children: [
              {
                id: ROUTES.ADMIN.CUSTOMER_LEAD.DETAIL,
                url: ROUTES.ADMIN.CUSTOMER_LEAD.DETAIL,
                paramKey: ROUTES.URL_PARAMS.CUSTOMER_LEAD_ID,
                title: "White Label Lead Detail",
                messageId: "sidebar.customerLeadDetail",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },

          {
            id: ROUTES.SEND_BYTE_WALLETS.LIST,
            url: ROUTES.SEND_BYTE_WALLETS.LIST,
            title: "Wallets",
            messageId: "sidebar.whiteLabelLeadTransactions.wallets",
            icon: <IoWallet />,
          },
          {
            id: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.LIST,
            url: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.LIST,
            title: "Wallet Pool",
            messageId: "sidebar.whiteLabelLeadTransactions.walletAccounts",
            icon: <FaBtc />,
            type: "item",
            children: [
              {
                id: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.WALLET_ID,
                url: ROUTES.SEND_BYTE_WALLET_ACCOUNTS.WALLET_ID,
                paramKey: ROUTES.URL_PARAMS.WALLET_ID,
                title: "Wallet",
                messageId: "common.wallet",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },

          {
            id: ROUTES.ADMIN.CUSTOMER_LEAD.BLOCKCHAIN_PAYMENT_REQUESTS.LIST,
            url: ROUTES.ADMIN.CUSTOMER_LEAD.BLOCKCHAIN_PAYMENT_REQUESTS.LIST,
            title: "Blockchain Payment Requests",
            messageId:
              "sidebar.whiteLabelLeadTransactions.blockchainPaymentRequests",
            icon: <PiGitPullRequestLight />,
          },

          {
            id: ROUTES.ADMIN.CUSTOMER_LEAD.BLOCKCHAIN_PAYMENTS.LIST,
            url: ROUTES.ADMIN.CUSTOMER_LEAD.BLOCKCHAIN_PAYMENTS.LIST,
            title: "Blockchain Payments",
            messageId: "sidebar.whiteLabelLeadTransactions.blockchainPayments",
            icon: <TbZoomMoney />,
          },
        ],
      },

      {
        id: "tftSales",
        title: "TFT Sales",
        messageId: "sidebar.tftSales",
        type: "collapse",
        icon: <GiSoundWaves />,
        children: [
          {
            id: ROUTES.ADMIN.TFT_SALES.LEAD_LIST,
            url: ROUTES.ADMIN.TFT_SALES.LEAD_LIST,
            title: "TFT Sales",
            messageId: "sidebar.tftSalesLeads",
            type: "item",
            icon: <IoPeople />,
          },
          {
            id: ROUTES.ADMIN.TFT_SALES.CALL_LIST,
            url: ROUTES.ADMIN.TFT_SALES.CALL_LIST,
            title: "TFT Sales Calls",
            messageId: "sidebar.tftSalesCalls",
            type: "item",
            icon: <FaHeadphonesSimple />,
          },
          {
            id: ROUTES.ADMIN.XAI_CALL_MODELS.LIST,
            url: ROUTES.ADMIN.XAI_CALL_MODELS.LIST,
            title: "Call Models",
            messageId: "sidebar.xaiCallModels",
            type: "item",
            icon: <LuBrainCircuit />,
          },
          {
            id: ROUTES.ADMIN.CUSTOMER_VOIP_CONFIG.LIST,
            url: ROUTES.ADMIN.CUSTOMER_VOIP_CONFIG.LIST,
            title: "Customer VoIP Configs",
            messageId: "sidebar.customerVoipConfigs",
            type: "item",
            icon: <BiSolidPhoneCall />,
          },
        ],
      },

      {
        id: "marketPlace",
        title: "Market Place",
        messageId: "sidebar.marketPlace",
        type: "collapse",
        icon: <FiShoppingCart />,
        children: [
          {
            id: ROUTES.ADMIN.MARKET_PLACE.EMAIL_TEMPLATE.LIST,
            url: ROUTES.ADMIN.MARKET_PLACE.EMAIL_TEMPLATE.LIST,
            title: "Email Templates",
            messageId: "sidebar.marketPlace.emailTemplates",
            icon: <AiOutlineFileText />,
            type: "item",
            children: [
              {
                id: ROUTES.ADMIN.MARKET_PLACE.EMAIL_TEMPLATE.DETAIL,
                url: ROUTES.ADMIN.MARKET_PLACE.EMAIL_TEMPLATE.DETAIL,
                paramKey: ROUTES.URL_PARAMS.MARKET_PLACE_EMAIL_TEMPLATE_ID,
                title: "Email Template Detail",
                messageId: "sidebar.marketPlace.emailTemplateDetail",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },
          {
            id: ROUTES.ADMIN.MARKET_PLACE.SUMMARY.LIST,
            url: ROUTES.ADMIN.MARKET_PLACE.SUMMARY.LIST,
            title: "Summaries",
            messageId: "sidebar.marketPlace.summaries",
            icon: <SlNote />,
            type: "item",
            children: [
              {
                id: ROUTES.ADMIN.MARKET_PLACE.SUMMARY.DETAIL,
                url: ROUTES.ADMIN.MARKET_PLACE.SUMMARY.DETAIL,
                paramKey: ROUTES.URL_PARAMS.MARKET_PLACE_SUMMARY_ID,
                title: "Summary Detail",
                messageId: "sidebar.marketPlace.summaryDetail",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },
          {
            id: ROUTES.ADMIN.MARKET_PLACE.WHATSAPP_MESSAGE.LIST,
            url: ROUTES.ADMIN.MARKET_PLACE.WHATSAPP_MESSAGE.LIST,
            title: "WhatsApp Messages",
            messageId: "sidebar.marketPlace.whatsappMessages",
            icon: <FaWhatsapp />,
            type: "item",
            children: [
              {
                id: ROUTES.ADMIN.MARKET_PLACE.WHATSAPP_MESSAGE.DETAIL,
                url: ROUTES.ADMIN.MARKET_PLACE.WHATSAPP_MESSAGE.DETAIL,
                paramKey: ROUTES.URL_PARAMS.MARKET_PLACE_WHATSAPP_MESSAGE_ID,
                title: "WhatsApp Message Detail",
                messageId: "sidebar.marketPlace.whatsappMessageDetail",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },
          {
            id: ROUTES.ADMIN.MARKET_PLACE.TRADER_ANALYSIS.LIST,
            url: ROUTES.ADMIN.MARKET_PLACE.TRADER_ANALYSIS.LIST,
            title: "Trader Analyses",
            messageId: "sidebar.marketPlace.traderAnalyses",
            icon: <TbChartLine />,
            type: "item",
            children: [
              {
                id: ROUTES.ADMIN.MARKET_PLACE.TRADER_ANALYSIS.DETAIL,
                url: ROUTES.ADMIN.MARKET_PLACE.TRADER_ANALYSIS.DETAIL,
                paramKey: ROUTES.URL_PARAMS.MARKET_PLACE_TRADER_ANALYSIS_ID,
                title: "Trader Analysis Detail",
                messageId: "sidebar.marketPlace.traderAnalysisDetail",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },
          {
            id: ROUTES.ADMIN.MARKET_PLACE.TRADE_ADVISE.LIST,
            url: ROUTES.ADMIN.MARKET_PLACE.TRADE_ADVISE.LIST,
            title: "Trade Advises",
            messageId: "sidebar.marketPlace.tradeAdvises",
            icon: <TbBulb />,
            type: "item",
            children: [
              {
                id: ROUTES.ADMIN.MARKET_PLACE.TRADE_ADVISE.DETAIL,
                url: ROUTES.ADMIN.MARKET_PLACE.TRADE_ADVISE.DETAIL,
                paramKey: ROUTES.URL_PARAMS.MARKET_PLACE_TRADE_ADVISE_ID,
                title: "Trade Advise Detail",
                messageId: "sidebar.marketPlace.tradeAdviseDetail",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },
          {
            id: ROUTES.ADMIN.MARKET_PLACE.NOTE_VALIDATION.LIST,
            url: ROUTES.ADMIN.MARKET_PLACE.NOTE_VALIDATION.LIST,
            title: "Note validation",
            messageId: "sidebar.marketPlace.noteValidation",
            icon: <TbNote />,
            type: "item",
          },
          {
            id: ROUTES.ADMIN.MARKET_PLACE.FRAUD_DETECTION.LIST,
            url: ROUTES.ADMIN.MARKET_PLACE.FRAUD_DETECTION.LIST,
            title: "Fraud Detection",
            messageId: "sidebar.marketPlace.fraudDetection",
            icon: <FaFingerprint />,
            type: "item",
          },
        ],
      },
    ],
  },

  {
    id: "systemManagement",
    title: "System Management",
    messageId: "sidebar.systemManagement",
    type: "group",
    icon: <FaCog />,
    children: [
      {
        id: ROUTES.PRODUCT.LIST,
        url: ROUTES.PRODUCT.LIST,
        title: "Products",
        messageId: "sidebar.products",
        icon: <FiShoppingCart />,
        type: "item",
      },
      {
        id: ROUTES.NOTES.LIST,
        url: ROUTES.NOTES.LIST,
        title: "Notes",
        messageId: "sidebar.notes",
        icon: <SlNote />,
        type: "item",
      },
      {
        id: ROUTES.MANAGER.LIST,
        url: ROUTES.MANAGER.LIST,
        title: "Managers",
        messageId: "sidebar.managers",
        icon: <HiMiniUserGroup />,
        type: "item",
        children: [
          {
            id: ROUTES.MANAGER.DETAIL,
            url: ROUTES.MANAGER.DETAIL,
            paramKey: ROUTES.URL_PARAMS.MANAGER_ID,
            title: "Manager Detail",
            messageId: "sidebar.managerDetail",
            type: "item",
            dontShowInSidebar: true,
          },
        ],
      },
      // {
      //   id: ROUTES.WALLET_ACCOUNTS.LIST,
      //   url: ROUTES.WALLET_ACCOUNTS.LIST,
      //   title: "Wallet Accounts",
      //   messageId: "sidebar.walletAccounts",
      //   icon: <FaBtc />,
      //   type: "item",
      //   children: [
      //     {
      //       id: ROUTES.WALLET_ACCOUNTS.WALLET_ID,
      //       url: ROUTES.WALLET_ACCOUNTS.WALLET_ID,
      //       paramKey: ROUTES.URL_PARAMS.WALLET_ID,
      //       title: "Wallet",
      //       messageId: "sidebar.wallet",
      //       type: "item",
      //       dontShowInSidebar: true,
      //     },
      //   ],
      // },

      {
        id: "telegramBot",
        title: "Telegram Bot",
        messageId: "sidebar.telegramBot",
        icon: <FaTelegram />,
        type: "collapse",
        children: [
          {
            id: ROUTES.ADMIN.TELEGRAM_BOT.TELEGRAM_BOT_CONFIG.LIST,
            url: ROUTES.ADMIN.TELEGRAM_BOT.TELEGRAM_BOT_CONFIG.LIST,
            title: "Telegram Bot Config",
            messageId: "sidebar.telegramBotConfigs",
            icon: <RiListSettingsFill />,
            type: "item",
            children: [
              {
                id: ROUTES.ADMIN.TELEGRAM_BOT.TELEGRAM_BOT_CONFIG.DETAIL,
                url: ROUTES.ADMIN.TELEGRAM_BOT.TELEGRAM_BOT_CONFIG.DETAIL,
                paramKey: ROUTES.URL_PARAMS.CONFIG_ID,
                title: "Telegram Bot Config Detail",
                messageId: "sidebar.telegramBotConfigDetail",
                type: "item",
                dontShowInSidebar: true,
              },
            ],
          },
          {
            id: ROUTES.ADMIN.TELEGRAM_BOT.TELEGRAM_BOT_USERS.LIST,
            url: ROUTES.ADMIN.TELEGRAM_BOT.TELEGRAM_BOT_USERS.LIST,
            title: "Telegram Bot Users",
            messageId: "sidebar.telegramBotUsers",
            icon: <PiUserListFill />,
            type: "item",
          },
        ],
      },

      {
        id: "settings",
        title: "Settings",
        messageId: "sidebar.settings",
        icon: <FaCog />,
        type: "collapse",
        children: [
          {
            id: ROUTES.ADMIN.SETTINGS.APP_RESTRICTION_CONFIG.LIST,
            url: ROUTES.ADMIN.SETTINGS.APP_RESTRICTION_CONFIG.LIST,
            title: "App Restriction Config",
            messageId: "sidebar.appRestrictionConfig",
            icon: <MdOutlineWifiPassword />,
            type: "item",
          },
          {
            id: ROUTES.ADMIN.SETTINGS.TWO_FACTOR_AUTH_CONFIG.LIST,
            url: ROUTES.ADMIN.SETTINGS.TWO_FACTOR_AUTH_CONFIG.LIST,
            title: "Two Factor Auth Config",
            messageId: "sidebar.twoFactorAuthConfig",
            icon: <FaFingerprint />,
            type: "item",
          },
          {
            id: ROUTES.ADMIN.SETTINGS.BILLING_CONFIGS.LIST,
            url: ROUTES.ADMIN.SETTINGS.BILLING_CONFIGS.LIST,
            title: "Billing Configs",
            messageId: "sidebar.billingConfigs",
            icon: <GrMoney />,
            type: "item",
          },
        ],
      },
    ],
  },

  // {
  //   id: "messages",
  //   title: "Messages",
  //   messageId: "common.messages",
  //   type: "group",
  //   children: [
  //     {
  //       id: "/messages/telegram",
  //       url: "/messages/telegram",
  //       title: "Telegram",
  //       messageId: "common.telegram",
  //       icon: <FaTelegram />,
  //       type: "item",
  //     },
  //   ],
  // },

  // don't show in sidebar
  {
    id: "myProfile",
    title: "My Profile",
    messageId: "sidebar.myProfile",
    type: "item",
    url: ROUTES.MY_PROFILE.LIST,
    icon: <FaUser />,
    dontShowInSidebar: true,
    children: [
      {
        id: ROUTES.MY_PROFILE.DETAIL_TAB,
        url: ROUTES.MY_PROFILE.DETAIL_TAB,
        title: "My Profile",
        messageId: "sidebar.myProfile",
        paramKey: ROUTES.URL_PARAMS.TAB,
        type: "item",
        dontShowInSidebar: true,
      },
    ],
  },
  {
    id: "notifications",
    title: "Notifications",
    messageId: "sidebar.notifications",
    type: "item",
    url: ROUTES.NOTIFICATIONS.LIST,
    icon: <FaBell />,
    dontShowInSidebar: true,
  },
];

export default adminRoutesConfig;
